import styles from './sales-chart.module.scss';
import WebkuaChart from '../webkua-chart/webkua-chart';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface SalesChartProps { }

export function SalesChart(props: SalesChartProps) {
  const { t } = useTranslation();
  return <WebkuaChart
    title={t("standard.sales")}
    startDate={new Date(2023, 0, 1)}
    endDate={new Date()}
    url='charts/sales'
  />
}

export default SalesChart;